module.exports = __webpack_public_path__ + "static/img/screen6.e34678cb.png";